import React from "react";
import { Typography } from "antd";

interface BasisBlockProps {
  basisOfInsight: string[];
}

const BasisBlock: React.FC<BasisBlockProps> = ({ basisOfInsight }) => {
  const basisPills = basisOfInsight.map(
    (b) => b.charAt(0).toUpperCase() + b.slice(1),
  );

  if (basisPills.length === 0) {
    return null;
  }

  return (
    <div>
      <Typography.Title level={5} style={{ margin: 0 }}>
        ANALYZED ON
      </Typography.Title>
      <div className="aic-basis-wrapper flex flex-wrap gap-2 mt-3">
        {basisPills.map((p, i) => (
          <span className="aic-basic-chip" key={i}>
            {p}
          </span>
        ))}
      </div>
    </div>
  );
};

export default BasisBlock;
